import Home from "./home";
import NavBar from "./components/navBar";
import Footer from "./components/footer";
import Projects from "./projects";
import { Routes, Route } from "react-router-dom";
import ScrollReveal from 'scrollreveal'
import { useEffect } from 'react'


const sr = ScrollReveal({
    distance: '60px',
    reset: false,
    duration: 1200,
    delay: 200,
})

export default function App() {
    useEffect(() => {
        sr.reveal(`.home__data`, { origin: 'top', reset: false, duration: 2500, })
        sr.reveal(`.home__handle`, { delay: 700, origin: 'top', reset: false, duration: 2500, })
        sr.reveal(`.home__social, .home__scroll`, { delay: 900, origin: 'bottom', reset: false, duration: 2500, })
        sr.reveal(`.about__description, .about__box, .services__card,
                .work__card, .contact__form_input, .education__card, .projects__content,
                .contact__form-tag`, { origin: 'left', distance: '60px' })
        sr.reveal(`.contact__card, .skills__content, .about__img, .btn, .work__filters,
                .testimonial__container`, { origin: 'bottom' })
        sr.reveal(`.section__subtitle, .section__title`, { distance: '0px', easing: 'ease-in' })
        sr.reveal(`.footer__container`, { origin: 'top', distance: '200px', duration: 2000 })

    }, [])
    return (
        <>
            <NavBar />
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/projects" element={<Projects />} />
            </Routes>
            <Footer />
        </>
    )
}




